function findNextUnusedName(name: string, usedNames: string[]) {
  if (!usedNames.includes(name)) {
    return name;
  }
  var i = 2;
  while (usedNames.includes(name.trim() + " " + i)) {
    i++;
  }
  return name + " " + i;
}

export default findNextUnusedName;
